import {ROUTES} from '../../../config'

export const getInitialProps = async ({routeInfo, context: {i18n, domain}}) => {
  const {
    location: {pathname: path},
    params: {
      make: makeUrlParam,
      model: modelUrlParam,
      bodyType: bodyTypeUrlParam,
      doors: doorsUrlParam,
      version: versionUrlParam
    }
  } = routeInfo

  const config = domain.get('config')
  const {DEFAULT_SEARCH, OFFER_TYPE_NEW, HAS_NEW_VEHICLE_ADS_LIST_ENABLED} = config.get('search')

  const isBodyTypePage = Boolean(bodyTypeUrlParam)

  const {
    TECHNICAL_DETAILS: {MAKE, MODEL, BODY_TYPE}
  } = ROUTES

  const TECHNICAL_DETAILS_MAKE_URL = `${MAKE.replace(':make', makeUrlParam)}/`
  const TECHNICAL_DETAILS_MODEL_URL = `${MODEL.replace(':make', makeUrlParam).replace(':model', modelUrlParam)}/`
  const TECHNICAL_DETAILS_BODY_TYPE_URL = `${BODY_TYPE.replace(':make', makeUrlParam)
    .replace(':model', modelUrlParam)
    .replace(':bodyType', bodyTypeUrlParam)
    .replace(':doors', doorsUrlParam)}/`

  const urlToRedirect = isBodyTypePage ? TECHNICAL_DETAILS_MODEL_URL : TECHNICAL_DETAILS_MAKE_URL

  if (versionUrlParam) {
    return {
      __HTTP__: {redirectTo: TECHNICAL_DETAILS_BODY_TYPE_URL}
    }
  }

  const {culture} = i18n

  const serverErrors = []

  const getModelInfo = async () => {
    try {
      const response = await domain
        .get('get_model_info_vehicles_use_case')
        .execute({make: makeUrlParam, model: modelUrlParam})
      return response
    } catch (error) {
      serverErrors.push(error)
    }
  }

  const getBodyTypeInfo = async () => {
    try {
      const response = await domain.get('get_body_type_info_vehicles_use_case').execute({
        make: makeUrlParam,
        model: modelUrlParam,
        bodyType: bodyTypeUrlParam,
        doors: doorsUrlParam
      })
      return response
    } catch (error) {
      serverErrors.push(error)
    }
  }

  const initialPageInfo = isBodyTypePage ? await getBodyTypeInfo() : await getModelInfo()

  const pageInfoResponse = initialPageInfo?.modelInfo

  const {make: makeName, makeId, model: modelName, modelId} = pageInfoResponse || {}

  const getTotalResultsForNewVehicle = async () => {
    const search = {
      ...DEFAULT_SEARCH,
      offerTypeId: OFFER_TYPE_NEW,
      makeId,
      model: {id: modelId}
    }
    return domain.get('get_total_results_ads_use_case').execute(search)
  }

  const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})

  const [[seoDataError, seoDataResponse], tagclouds, [, breadcrumb]] = await Promise.all([
    domain.get('get_seo_data_use_case').execute({
      culture,
      pageName,
      params: {
        make: makeUrlParam,
        model: modelUrlParam,
        bodyType: bodyTypeUrlParam, // TODO: check how to get bodyTypeIds MTR-56077
        doors: pageInfoResponse?.doors,
        year: pageInfoResponse?.year
      }
    }),
    domain.get('get_tagcloud_seo_use_case').execute({pageName, makeId: pageInfoResponse?.makeId}),
    domain.get('get_breadcrumbs_breadcrumb_use_case').execute({
      pageName,
      params: {
        section: makeUrlParam,
        model: modelUrlParam,
        bodyType: bodyTypeUrlParam,
        doors: pageInfoResponse?.doors
      }
    })
  ])

  const seoData = seoDataResponse || {}

  const hasCriticalServerErrors = !initialPageInfo || !Object.keys(initialPageInfo).length

  let totalResults = 0
  let hasNewVehicles = false
  if (HAS_NEW_VEHICLE_ADS_LIST_ENABLED) {
    const [, totalResultsResponse] = await getTotalResultsForNewVehicle()
    totalResults = totalResultsResponse.totalResults
    hasNewVehicles = totalResults > 0
  }

  return {
    ...(hasCriticalServerErrors && {__HTTP__: {redirectTo: urlToRedirect}}),
    bodyType: bodyTypeUrlParam,
    bodyTypeName: pageInfoResponse?.bodyType,
    breadcrumb,
    doors: pageInfoResponse?.doors,
    helmet: seoData.head,
    isBodyTypePage,
    makeId,
    makeName,
    makeUrlParam,
    modelName,
    modelUrlParam,
    hasNewVehicles,
    pageErrors: {
      seoDataError
    },
    pageName,
    serverErrors,
    tagclouds,
    ...(initialPageInfo && {initialPageInfo})
  }
}
